import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'hockey-ready-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-green px-2 text-white shadow-sm" data-id="element-32" data-mp="uex4z5zdzsu9">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-33" data-mp="ygqwoorltmia">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-34" data-mp="1m5tdjueezbbq">
          ⚡ AANBIEDING EINDIGT OVER:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`Nog ${timeLeft.hours} uur, ${timeLeft.minutes} minuten en ${timeLeft.seconds} seconden`} data-id="element-35" data-mp="1dc6kic1lcm68">
          <TimerUnit value={timeLeft.hours} label="UUR" data-id="element-36" data-mp="1hbfg7mg6yu4f" />
          <span className="text-xs font-bold" data-id="element-37" data-mp="252kwg2q1nof9">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-38" data-mp="29tui6s8h27lv" />
          <span className="text-xs font-bold" data-id="element-39" data-mp="29vdy2hq7ugn4">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEC" data-id="element-40" data-mp="2jql6cn88y7lq" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-41" data-mp="2ap4xijx2ydjm">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-42" data-mp="25r3c3sc6m24z">{label}</span>
    </span>;
}